import SpriteSymbol from "../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-picture",
  "use": "icon-picture-usage",
  "viewBox": "0 0 24 24",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" fill=\"#999\" fill-rule=\"evenodd\" viewBox=\"0 0 24 24\" id=\"icon-picture\"><path d=\"M24 22H0V2h24zM23 3H1v18h22zm-1 16H3l4-7.492 3 3.048L15.013 7zm-11.848-2.865-2.91-2.956L4.668 18h15.593l-5.303-9.108-4.806 7.243zM5.5 5a2.5 2.5 0 0 1 0 5 2.5 2.5 0 0 1 0-5m0 1a1.5 1.5 0 1 1-.001 3.001A1.5 1.5 0 0 1 5.5 6\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol